import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import RegisterPage from "./pages/RegisterPage";
import SponsorshipPage from "./pages/SponsorshipPage";
import FundraisingPage from "./pages/FundraisingPage";
import InfoPage from "./pages/InfoPage";
import VenuePage from "./pages/VenuePage";
import AdminPage from "./pages/AdminPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="register" element={<RegisterPage />} />
            <Route path="sponsorship" element={<SponsorshipPage />} />
            <Route path="fundraising" element={<FundraisingPage />} />
            <Route path="venue" element={<VenuePage />} />
            <Route path="info" element={<InfoPage />} />
          </Route>
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
